import {AutoComplete, Col, Modal, Row} from "antd";
import {useContext, useState} from "react";
import AvatarPopover from "../publications/AvatarPopover";
import {UiTextsContext} from "../../contexts/Contexts";
import { getRecomendationsService } from "../../../infrastructure/services/PublicationService";
import "../../styles/fonts.css";
import "../../styles/modals.css";
import { showErrorMessage } from "../utils/messages";
import { useLocationMessages } from "../../../infrastructure/hooks/useInterfaceMessages";

export const ModalLocation = ({
  location,
  setLocation,
  open,
  setOpen
}) => {
  const {texts} = useContext(UiTextsContext);
  const locationMessages = useLocationMessages();
  const [locationOptions, setLocationOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const onCloseModal = () => {
    setLocationOptions([]);
    setLocation("");
    setSearchText("");
    setOpen(false);
  };

  const onSelect = (value, option) => {
    const selectedOption =
      option?.originalItem ||
      locationOptions.find((item) => item.value === value)?.originalItem;
    const selectedLocation =
      selectedOption?.displayText || selectedOption?.formattedAddress || value;

    setLocation(selectedLocation);
    setSearchText("");
    setOpen(false);
  };

  const onChange = (value) => {
    setSearchText(value); 
    setLocation(value);   
    if (!value) {
      setLocationOptions([]);
    }
  };

  const onSearch = async (searchText) => {
    setSearchText(searchText);
    
    if (!searchText) {
      setLocationOptions([]);
      return;
    }
    
    setLoading(true);
    try {
      const response = await getRecomendationsService(searchText);
      const options = response.map((item) => ({
        value: item.displayText || item.formattedAddress,
        label: <AvatarPopover infoAddress={item} />,
        originalItem: item
      }));
      setLocationOptions(options);
    } catch (error) {
      console.error("Error fetching recommendations", error);
      showErrorMessage(texts?.ER0053 || locationMessages.suggestionsFailed);
      setLocationOptions([]);
    } finally {
      setLoading(false);
    }
  };

  return(
    <Modal
      open={open}
      onCancel={onCloseModal}
      centered={true}
      header={<></>}
      footer={<></>}
      width={720}
    >
      <Col className={"publication-location-inner"}>
        <Row justify={"center"} style={{marginBottom: "2vh"}}>
          <span className={"em2-400"}>
            {texts?.LB0145 || "Search location"}
          </span>
        </Row>
        <Row justify={"center"}>
          <AutoComplete
            value={searchText}
            options={locationOptions}
            onSearch={onSearch}
            onSelect={onSelect}
            onChange={onChange}
            variant={"filled"}
            style={{width: "100%"}}
            placeholder={`${texts?.LB0145 || "Search location"}...`}
            popupMatchSelectWidth={true}
            popupClassName="location-popover"
            loading={loading}
            autoFocus
            notFoundContent={searchText && !loading ? texts?.LB0418 : null}
          />
        </Row>
      </Col>
    </Modal>
  );
};
